module.exports = __webpack_public_path__ + "img/splash.dfe37fc2.png";